// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { alliedUnirversityLinksStyles } from "@awc/App/Widgets/AlliedUnirversityLinks/AlliedUnirversityLinks";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

alliedUnirversityLinksStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
    `,
};

alliedUnirversityLinksStyles.actionClickable = {
    css: css`
        height: 135px;
        width: 140px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-block: 8px;
        row-gap: 8px;
        &:hover,
        &:focus {
            background: ${color("secondary.main")};
            ${TypographyStyle} {
                color: ${color("common.ui1")};
            }
        }
    `,
};

alliedUnirversityLinksStyles.title = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    color: "text",
    weight: fontConfig.weight.bold,
};

alliedUnirversityLinksStyles.image = {
    css: css`
        img {
            width: auto;
            hright: auto;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    `,
};
